// extracted by mini-css-extract-plugin
module.exports = {"main":"MainLayout_main__1XmCy","main__content":"MainLayout_main__content__1X6ne"};